// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3320":"4d4e71ad11768df2","9669":"648608e9cf9b644f"}[chunkId] + ".js";
};